import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { RegionTranslationEntity } from './RegionTranslationEntity'

export class RegionEntity {
  id?: number
  location?: LngLatEntity
  boundary?: string | null
  countryId?: number
  translations?: Array<RegionTranslationEntity> | null
}
